import makeFAIcon from "utils/makeFAIcon";

import { faBath, faSquare } from "@fortawesome/free-solid-svg-icons";

export const BathIcon = makeFAIcon(faBath);
export const TileIcon = makeFAIcon(faSquare);
